import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui';
import { ReactNode } from 'react';

type TProps = {
  description?: ReactNode;
  title: string;
}

const FormSearchUserHeader = ({ title, description }: TProps) => (
  <DialogHeader>
    <DialogTitle>
      {title}
    </DialogTitle>
    <DialogDescription>
      {description}
    </DialogDescription>
  </DialogHeader>
);

export default FormSearchUserHeader;
